import api from 'api';

export const loadApplications = api(
  'GET /api/postbacks-report/filters/applications'
);

export const loadAffiliates = api(
  'GET /api/postbacks-report/filters/affiliates'
);

export const loadEvents = api('GET /api/postbacks-report/filters/events');
